import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { HiExclamationTriangle } from "react-icons/hi2";
import type { RoleDto } from "@/api/types/dtos/role-privilege.dto";

interface DeleteRoleDialogProps {
  open: boolean;
  role: RoleDto | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

const DeleteRoleDialog: React.FC<DeleteRoleDialogProps> = ({
  open,
  role,
  onConfirm,
  onCancel,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      aria-labelledby="delete-role-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        id="delete-role-dialog-title"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        <HiExclamationTriangle size={22} style={{ color: "#f44336" }} />
        Eliminar Rol
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          ¿Estás seguro de que deseas eliminar el rol <strong>{role?.name || "—"}</strong>? Esta
          acción no se puede deshacer.
        </DialogContentText>
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 1,
            bgcolor: "warning.50",
            border: "1px solid",
            borderColor: "warning.200",
          }}
        >
          <Typography variant="body2" color="warning.dark">
            Los usuarios que tengan este rol asignado perderán los privilegios asociados.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRoleDialog;
